module.exports = __webpack_public_path__ + "static/media/laitues.e2b20128.svg";